import React from 'react';
// import MemberOnly from 'components/Promotions/InnerPage/MemberOnly';
// import ActivityFlow from 'components/Promotions/InnerPage/ActivityFlow';
// import WinningAnnouncement from 'components/Promotions/InnerPage/WinningAnnouncement';
// import Schemes from 'components/Promotions/InnerPage/Schemes';
// import ActivityNotes from 'components/Promotions/InnerPage/ActivityNotes';
// import PageNavControls from 'components/PageNavControls';

const PromotionsInnerPageB: React.FC = () => (
  <div className="promotions-inner-page promotions-inner-page-b">
    {
      /**

    <MemberOnly>
    <MemberOnly.Head />
    <MemberOnly.InnerPageBAds />
  </MemberOnly>

  <ActivityFlow />

  <WinningAnnouncement />

  <Schemes>
    <Schemes.InnerPageBSchemes />
  </Schemes>

  <ActivityNotes />

  <PageNavControls
    prevBtnLink="/"
    nextBtnLink="/"
    navBtnLink="/"
    navBtnText="回活動頁"
  />
      */
    }
  </div>
);

export default PromotionsInnerPageB;
